module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0069.jpg?v=5c01de36";